import { RootState } from '@/core/redux/store';
import { routes } from '@/utils/routes/routes';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router';
import ProductCard from './productCard';
import { postData } from '@/services/api.service';
import Spinner from './Components/spinner';
import NoProducts from './Components/noProduct';

const CategoryDetails = () => {
  const { id } = useParams();
  const [quantities, setQuantities] = useState<{ [key: number]: number }>({});
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const type = location.state?.type;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const payload = {
        category: id,
        brand: type == 'brand' ? id : null,
        page: 1,
        limit: 10,
        sort_by: 'price',
        sort: 'desc',
        type: 'service',
      };
      try {
        const response = await postData('products', payload);
        if (response.status === 200 || response.status === 201) {
          setProducts(response?.data?.data?.data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const activeTab = useSelector(
    (state: RootState) => state.common.activeCustomerTab
  );

  const handleQuantityChange = (productId: number, newValue: number) => {
    setQuantities((prev) => ({ ...prev, [productId]: newValue }));
  };

  const handleAddToCart = (productId: number) => {
    console.log(
      `Added product ${productId} to cart with quantity ${quantities[productId] || 1}`
    );
  };

  const handleAddToWishlist = (productId: number) => {
    console.log(`Added product ${productId} to wishlist`);
  };

  const handleQuickView = (productId: number) => {
    console.log(`Quick view for product ${productId}`);
  };

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="page-title">{activeTab}</h1>
              <ul>
                <li>
                  <Link to={routes.home}>Dashboard</Link>
                </li>
                <li className="active">
                  {activeTab
                    .split('-')
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {products.length > 0 ? (
                <div className="product-grid my-3 my-md-5">
                  {products.map((product) => (
                    <ProductCard
                      key={product.id}
                      product={product}
                      quantity={quantities[product.id] || 1}
                      onQuantityChange={handleQuantityChange}
                      onAddToCart={handleAddToCart}
                      onAddToWishlist={handleAddToWishlist}
                      onQuickView={handleQuickView}
                    />
                  ))}
                </div>
              ) : (
                <NoProducts />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CategoryDetails;
